import { useState } from "react";
import { ExternalSection } from "components";
import { InquiryComplete, InquiryForm, InquiryFormProps } from "components/voc";

const Form = ({ onComplete }: InquiryFormProps) => {
  return (
    <>
      <ExternalSection className="page_inquiry">
        <InquiryForm onComplete={onComplete} />
      </ExternalSection>
    </>
  );
};

const Complete = () => {
  return (
    <>
      <ExternalSection className="page_inquiry_end">
        <InquiryComplete />
      </ExternalSection>
    </>
  );
};

const Inquiry = () => {
  const [completeState, setCompleteState] = useState(false);

  return (
    <>
      {!completeState && <Form onComplete={() => setCompleteState(true)} />}
      {completeState && <Complete />}
    </>
  );
};

export default Inquiry;
